<div class="shell">
  <header class="shell-top">
    <button mat-icon-button class="shell-burger" (click)="navOpen = !navOpen" aria-label="Menu">
      <mat-icon>menu</mat-icon>
    </button>

    <div class="shell-brand">
      <img class="shell-logo" src="assets/img/frigg-icon-150x42.png" alt="Frigg Kantine">
      <span class="shell-title">{{ 'shell.title' | translate }}</span>
    </div>

    <span class="shell-spacer"></span>

    <div class="shell-lang">
      <button class="shell-lang-btn" [class.shell-lang-active]="i18n.lang === 'en'" (click)="setLang('en')">EN</button>
      <button class="shell-lang-btn" [class.shell-lang-active]="i18n.lang === 'no'" (click)="setLang('no')">NO</button>
    </div>

    <mat-form-field appearance="outline" class="shell-customer" *ngIf="customers.length > 1">
      <mat-label>{{ 'shell.company' | translate }}</mat-label>
      <mat-select [value]="state.customerId" (selectionChange)="onCustomerChange($event.value)">
        <mat-option [value]="null">{{ 'shell.allCompanies' | translate }}</mat-option>
        <mat-option *ngFor="let c of customers" [value]="c.customerId">{{ c.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <span class="shell-company" *ngIf="customers.length === 1">{{ customers[0].name }}</span>

    <button mat-button [matMenuTriggerFor]="userMenu" class="shell-user">
      <mat-icon>account_circle</mat-icon>
      <span class="shell-user-name">{{ user.name || user.email }}</span>
      <mat-icon>expand_more</mat-icon>
    </button>
    <mat-menu #userMenu="matMenu">
      <div class="shell-menu-head">
        <div class="shell-menu-name">{{ user.name || '—' }}</div>
        <div class="shell-menu-email">{{ user.email }}</div>
        <div class="shell-menu-role">{{ user.role }}</div>
      </div>
      <button mat-menu-item (click)="signOut()">
        <mat-icon>logout</mat-icon> {{ 'shell.signOut' | translate }}
      </button>
    </mat-menu>
  </header>

  <div class="shell-body">
    <nav class="shell-nav" [class.shell-nav-open]="navOpen">
      <a routerLink="/overview" routerLinkActive="active" (click)="navOpen = false">
        <mat-icon>dashboard</mat-icon> {{ 'shell.overview' | translate }}
      </a>
      <a routerLink="/employees" routerLinkActive="active" (click)="navOpen = false">
        <mat-icon>groups</mat-icon> {{ 'shell.employees' | translate }}
      </a>
      <a routerLink="/catering" routerLinkActive="active" (click)="navOpen = false">
        <mat-icon>restaurant</mat-icon> {{ 'shell.catering' | translate }}
      </a>
      <a routerLink="/purchases" routerLinkActive="active" (click)="navOpen = false">
        <mat-icon>receipt_long</mat-icon> {{ 'shell.purchases' | translate }}
      </a>
      <a routerLink="/help" routerLinkActive="active" (click)="navOpen = false">
        <mat-icon>help_outline</mat-icon> {{ 'shell.help' | translate }}
      </a>
    </nav>

    <main class="shell-main">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
